export default {"src":"/_next/static/image/public/images/ic_video_consult_blue.65dcf40b940c14318861f5336dcc4df2.svg","height":16,"width":17};